import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ClubService } from 'src/app/services/club.service';
import { POINTS_CATALOGUE } from 'src/app/shared/utils';
import dayjs from 'dayjs';
import { AddCardComponent } from 'src/app/club/add-card/add-card.component';
import { ConfirmActionComponent } from '@shared/components/confirm-action/confirm-action.component';
import { TConfirmActionModal } from '@models/club.model';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-redeem',
  templateUrl: './redeem.component.html',
  styleUrls: ['./redeem.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatDialogModule, MatFormFieldModule, MatTooltipModule, MatProgressSpinnerModule, MatRippleModule, MatButtonModule, TranslateModule]
})
export class RedeemComponent implements OnInit {

  public user: any;
  public points: any;
  public card_id: any;
  public card_owner: any;
  public pointsSelected: any;
  public pointsCatalogue = POINTS_CATALOGUE;
  public hideButton = false;
  public validity = '';
  public name: string;

  public shared: boolean;
  public isPointsCheck = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private clubService: ClubService,
    private dialogRef: MatDialogRef<RedeemComponent>,
    private dialog: MatDialog
  ) {
    this.isPointsCheck = this.data?.isPointsCheck;
  }

  ngOnInit(): void {
    this.getValidityDate();
    if (this.data?.hideButton) {
      this.hideButton = true;
    }
    if (this.data?.card_id || this.data?.points || this.data?.card_owner) {
      this.card_id = this.data.card_id;
      this.points = this.data.card_data.Saldo;
      this.card_owner = this.data.card_data.Mensaje;
    } else {
      this.getUser();
    }
  }

  public async getUser(): Promise<any> {
    try {
      const { data } = await this.authService.getCurrentUser();
      this.user = data[0];
      this.card_owner = this.user.Mensaje;
      if (data[0].membership) {
        this.card_id = data[0].membership;
        try {
          const { data: clubAlsuperData } = await this.clubService.getClubPointsByNumber(this.card_id);
          this.card_owner = clubAlsuperData.membership_data[0].Mensaje;
          this.points = clubAlsuperData.membership_data[0].Saldo;
          this.shared = clubAlsuperData.shared;
        } catch (error) { }
      }
    } catch (error) { }
  }

  public getValidityDate(): void {
    const currentDate = new Date();
    let validityMonth: number;
    if ((currentDate.getMonth() + 1) % 2 !== 0) {
      validityMonth = currentDate.getMonth() + 1;
      if (validityMonth === 12) {
        validityMonth = 0;
      }
      const date = `${new Date().getFullYear()}/${validityMonth + 1}/01`;
      this.validity = dayjs(new Date(date)).endOf('month').format('DD/MM/YYYY');
    } else {
      this.validity = dayjs(currentDate).endOf('month').format('DD/MM/YYYY');
    }
  }

  public onSelectedPoints(points: any): void {
    if (points === 0) {
      this.pointsSelected = {
        points: 0,
        percent: 0
      };
    } else {
      this.pointsSelected = points;
    }
    this.onApplyingPoints();
  }

  public onApplyingPoints(): void {
    this.dialogRef.close(this.pointsSelected);
  }

  public deleteCard(): void {
    const data: TConfirmActionModal = {
      title: 'Eliminar tarjeta Club Alsuper',
      subtitle: '¿Estás seguro de eliminar la tarjeta Club Alsuper? De ser así, no podrás usar los puntos ni beneficios de esta tarjeta.',
      cancelText: 'Cancelar',
      confirmText: 'Eliminar',
      type: 'warn'
    };
    this.dialog.open(ConfirmActionComponent, {
      width: '360px',
      data,
      disableClose: true,
      autoFocus: false
    }).afterClosed().subscribe(({
      next: async (response: boolean) => {
        if (response === true) {
          await this.clubService.deleteClubAlsuperCard(this.card_id);
          this.clubService.reloadClubAlsuper$.emit(true);
          this.dialogRef.close();
        }
      }
    }));
  }

  public updateCard(): void {
    this.dialogRef.close();
    this.dialog.open(AddCardComponent, {
      panelClass: 'as-activate-club',
      autoFocus: false,
    });
  }
}
